import { j as a } from "../../../../jsx-runtime.BREq8dyb.js";
import { Box as s, Typography as o } from "@mui/joy";
import { memo as m } from "react";
import { S as e, d as i, a as l } from "../../../../index.BRz-o-Vs.js";
import p, { DqDatasetSyncIconSize as d } from "../DqDatasetSyncIcon/DqDatasetSyncIcon.js";
const n = m(({
  syncType: r,
  syncDirection: t
}) => /* @__PURE__ */ a.jsxs(s, { children: [
  /* @__PURE__ */ a.jsx(o, { level: "title-sm", children: t === e.IMPORT ? "Import dataset from" : t === e.EXPORT ? "Export dataset to" : "" }),
  /* @__PURE__ */ a.jsx(o, { level: "title-lg", startDecorator: /* @__PURE__ */ a.jsx(p, { size: d.md, syncType: r }), children: t === e.IMPORT ? i[r] : t === e.EXPORT ? l[r] : "" })
] }));
n.displayName = "DqDatasetSyncTitle";
export {
  n as default
};
//# sourceMappingURL=DqDatasetSyncTitle.js.map
